export function dragulaDecorator(componentBackingInstance) {
    if (this.props.isChannelOwner && componentBackingInstance) {
        this.props.dragulaInstance.containers.push(componentBackingInstance);
    }
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/drag-and-drop-helper.js